import { createContext, useContext } from "react";

const HubPortalContext = createContext(null);

export function usePortal() {
  return useContext(HubPortalContext);
}

export default HubPortalContext;
